<script type="text/javascript">
import { Feature } from "ol";
import {
  Point
} from "ol/geom";
import {
  Style,
  Fill as olFill,
  Stroke,
  Icon as olIcon,
  Text as olText,
  Circle as olCircle,
} from "ol/style";
import VectorLayer from "ol/layer/Vector";
import Vector from "ol/source/Vector";

import { ajax } from "jquery";
import * as turf from "@turf/turf";
import {
  transform,
  fromLonLat,
  addProjection,
  addCoordinateTransforms,
} from "ol/proj";
import {Loading} from "element-ui"
import { getLocalJson } from "../http/axios";

var colorCfg;
var voltageZoomCfg;
var contextMenuCfg

function addDays(date,_day)
{
  let b=date.getData();
  b=b+parseInt(_day)
  date.setDate(b);
  return date;
}


function addMonths(date,_month)
{
  let b=date.getMonth();
  b=b+parseInt(_month)
  date.setMonth(b-1)
  return new Date(date);
}

// 年月日
function formatDate(date,seprateChar)
{
    let year = date.getFullYear().toString();
    let month = date.getMonth()+1;
    let monthStr=month.toString()
    if(month<10)
    {
      monthStr="0"+monthStr;
    }

    let da =date.getDate();
    let daStr=da.toString()
    if(da<10)
    {
      daStr="0"+daStr;
    }
    if(!seprateChar)
      seprateChar="-"

    let timeStr = year + seprateChar + monthStr + seprateChar + daStr;
    return timeStr; 
}

// 年月日时分秒
function formatFullDate(date,datetimeSeparate,dateSeprate,timeSeprate)
{
  if(!datetimeSeparate)
    datetimeSeparate=" "

    return formatDate(date,dateSeprate)+datetimeSeparate+formatTime(date,timeSeprate); 
}

// 时分秒
function formatTime(date,timeSeprate)
{
    let mins = date.getMinutes();
    let sec = date.getSeconds();
    let hour=date.getHours()
    
    let hourStr=hour.toString()
    let minsStr =mins.toString()
    let secStr = sec.toString()

    if(!timeSeprate)
      timeSeprate=":"
      
    if(hour<10)
    {
      hourStr="0"+hour;
    }
  
    if(mins<10)
    {
      minsStr="0"+mins;
    }

    if(sec<10)
    {
      secStr="0"+sec;
    }
    let timeStr = hourStr + timeSeprate + minsStr + timeSeprate + secStr;
    return timeStr; 
}

function debounce(fn, delay) {
  var delay = delay || 200;
  var timer;
  return function () {
    var th = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
}

function safeGetJsonKey(obj, key, defaultVal) {
  if (obj == null) return defaultVal;
  if (obj.hasOwnProperty(key)) {
    if (obj[key] == null) return defaultVal;
    else return obj[key];
  } else return defaultVal;
}

function getFeatureProperties(feature) {
  let fetProp = feature.getGeometry().getProperties();
  if (JSON.stringify(fetProp) != "{}") return fetProp;
  else fetProp = feature.getProperties();
  return fetProp;
}

function valIsInArray(vList, val) {
  let i;
  for (i = 0; i < vList.length; i++) {
    if (val == vList[i]) break;
  }
  if (i == vList.length) return false;
  else return true;
}

var voltage = [];
var maxPos = [];
function initVoltageCfg() {
  let i;
  ajax({
    method: "GET",
    url: window.common.getConfPath("voltageLevel.json"),
    async: false,
  }).done(function (msg) {
    voltageZoomCfg = msg;
  });

  ajax({
    method: "GET",
    url: window.common.getConfPath("colorCfg.json"),
    async: false,
  }).done(function (msg) {
    colorCfg = msg;
  });
  for (i = 0; i < 10; i++) {
    voltage[i] = [];
    maxPos[i] = 0;
  }

  for (i = 0; i < voltageZoomCfg.length; i++) {
    let g = voltageZoomCfg[i];
    g.minZoom = parseInt(g.minZoom);
    for (let v = 0; v < g.voltage.length; v++) {
      let vv = g.voltage[v];
      let tv = {};
      tv.name = vv.name;
      let vVal = parseInt(vv.value);
      let k = parseInt(vVal / 1000) - 1;
      let voff = vVal - (k + 1) * 1000;
      if (maxPos[k] < voff) {
        for (let kk = maxPos[k]; kk < voff; kk++) {
          voltage[k].push(null);
        }
        maxPos[k] = voff;
      }
      tv.value = vv.value;
      tv.color = g.color;
      tv.minZoom = parseInt(g.minZoom);
      tv.groupName = g.groupName;
      tv.index = i;
      voltage[k][voff] = tv;
    }
  }
}
function initContextMenuCfg() {

    ajax({
        method: "GET",
        url:  window.common.getConfPath("contextMenuCfg.json"),
        async: false
    }).done(function (msg) {
        // layerStyleCfg = msg;
        contextMenuCfg = msg;
    });
    return contextMenuCfg

}


function getVoltageInfo(v) {
  let vVal = parseInt(v);
  let k = parseInt(vVal / 1000) - 1;
  // console.log(k,vVal,'k----------')

  if (k >= 10 || k < 0) {
    return {
      color: "default",
      styleInfo: safeGetJsonKey(colorCfg, "default", {
        hex: "#ee7700",
        icon: "default",
      }),
      name: "unknow",
      groupName: "unknow",
      minZoom: 14,
    };
  }
  let voff = vVal - (k + 1) * 1000;
  // console.log(voff , maxPos[k],'----------')

  if (voff > maxPos[k] || voff < 0) {
    return {
      color: "default",
      styleInfo: safeGetJsonKey(colorCfg, "default", {
        hex: "#ee7700",
        icon: "default",
      }),
      name: "unknow",
      groupName: "unknow",
      minZoom: 14,
    };
  }
  let t = null;
  try {
    t = voltage[k][voff];
    // console.log('>>>>',k,voff,voltage[k][voff],t)
    if (t == null) {
      return {
        color: "default",
        styleInfo: safeGetJsonKey(colorCfg, "default", {
          hex: "#ee7700",
          icon: "default",
        }),
        name: "unknow",
        groupName: "unknow",
        minZoom: 14,
        index:0
      };
    }
  } catch (e) {
    return {
      color: "default",
      styleInfo: safeGetJsonKey(colorCfg, "default", {
        hex: "#ee7700",
        icon: "default",
      }),
      name: "unknow",
      groupName: "unknow",
      minZoom: 14,
      index:0,
    };
  }
  t.styleInfo = safeGetJsonKey(colorCfg, t.color, {
    hex: "#ee7700",
    icon: "default",
  });
  return t;
}

function getVoltageFilter(curZoom) {
  let valCollection = [];

  for (let i = 0; i < voltageZoomCfg.length; i++) {
    let g = voltageZoomCfg[i];
    if (curZoom >= parseInt(g.minZoom)) {
      for (let v = 0; v < g.voltage.length; v++) {
        let vv = g.voltage[v];
        valCollection.push(vv.value);
      }
    }
  }
  return valCollection;
}

function getVoltageFilterStr(curZoom, valCollection) {
  for (let i = 0; i < voltageZoomCfg.length; i++) {
    let g = voltageZoomCfg[i];
    if (curZoom >= parseInt(g.minZoom)) {
      for (let v = 0; v < g.voltage.length; v++) {
        let vv = g.voltage[v];
        if (valCollection != "") valCollection += ",";
        valCollection += "'" + vv.value + "'";
      }
    }
  }
  return valCollection;
}

function sortLineCoordinates(lines) {
  let i, j;
  let points = [],
    pointsList = [];
  let foundFlag = [];
  let sortPoints = [];
  let p, l;
  let totalLines;
  totalLines = lines.length;
  for (l = 0; l < totalLines; l++) {
    let coors = lines[l].getFlatCoordinates();
    points = [];
    for (i = 0; i < coors.length; i += 2) {
      points.push(
        transform([coors[i], coors[i + 1]], "EPSG:3857", "EPSG:4326")
      );
    }
    pointsList.push(points);
    foundFlag[l] = 0;
  }
  l = pointsList[0].length;
  foundFlag[0] = 1;

  for (i = 0; i < l; i++) {
    sortPoints.push(pointsList[0][i]);
  }

  let foundCount = 1;
  while (true) {
    let sl = sortPoints.length;
    let fhead = sortPoints[0];
    let ftail = sortPoints[sl - 1];
    for (l = 0; l < totalLines; l++) {
      if (foundFlag[l] == 1) {
        continue;
      }
      j = pointsList[l].length;
      if (fhead[0] == pointsList[l][0][0] && fhead[1] == pointsList[l][0][1]) {
        //head to head ,reconvert pointlist ,except 0
        points = [];
        for (i = j - 1; i > 0; i--) {
          points.push(pointsList[l][i]);
        }
        sortPoints = points.concat(sortPoints);
        foundCount++;
        foundFlag[l] = 1;
        break;
      } else if (
        fhead[0] == pointsList[l][j - 1][0] &&
        fhead[1] == pointsList[l][j - 1][1]
      ) {
        //head to tail,append sortPiont[1,n] to pointlist
        for (i = 1; i < sl; i++, j++) {
          pointsList[l][j] = sortPoints[i];
        }
        sortPoints = pointsList[l];
        foundCount++;
        foundFlag[l] = 1;
        break;
      } else if (
        ftail[0] == pointsList[l][0][0] &&
        ftail[1] == pointsList[l][0][1]
      ) {
        //tial to head ,phonitsList excep 0 append to sortPoint
        for (i = 1; i < j; i++, sl++) {
          sortPoints[sl] = pointsList[l][i];
        }
        foundCount++;
        foundFlag[l] = 1;
        break;
      } else if (
        ftail[0] == pointsList[l][j - 1][0] &&
        ftail[1] == pointsList[l][j - 1][1]
      ) {
        //tial to tail ,phonitsList excep n-1 append to sortPoint
        for (i = j - 2; i >= 0; i--, sl++) {
          sortPoints[sl] = pointsList[l][i];
        }
        foundFlag[l] = 1;
        foundCount++;
        break;
      }
    }
    if (foundCount == totalLines) {
      break;
    }
    if (l == totalLines) {
      let minLen = 99999999;
      let minPos = 0;
      let minMode = 0;
      l = sortPoints.length;
      let fhead = sortPoints[0];
      let ftail = sortPoints[l - 1];
      for (i = 0; i < totalLines; i++) {
        if (foundFlag[i] == 1) continue;
        let from = turf.point(fhead);
        let to = turf.point(pointsList[i][0]);
        let distance = turf.distance(from, to, { units: "kilometers" });
        if (distance < minLen) {
          minPos = i;
          minMode = 0;
          minLen = distance;
        }
        to = turf.point(pointsList[i][pointsList[i].length - 1]);
        distance = turf.distance(from, to, { units: "kilometers" });
        if (distance < minLen) {
          minPos = i;
          minMode = 1;
          minLen = distance;
        }
        from = turf.point(ftail);
        to = turf.point(pointsList[i][0]);
        distance = turf.distance(from, to, { units: "kilometers" });
        if (distance < minLen) {
          minPos = i;
          minMode = 2;
          minLen = distance;
        }
        to = turf.point(pointsList[i][pointsList[i].length - 1]);
        distance = turf.distance(from, to, { units: "kilometers" });
        if (distance < minLen) {
          minPos = i;
          minMode = 3;
          minLen = distance;
        }
      }
      l = minPos;
      j = pointsList[l].length;
      if (minMode == 0) {
        points = [];
        for (i = j - 1; i > 0; i--) {
          points.push(pointsList[l][i]);
        }
        sortPoints = points.concat(sortPoints);
        foundCount++;
      } else if (minMode == 1) {
        sortPoints = pointsList[l].concat(sortPoints);
        foundCount++;
      } else if (minMode == 2) {
        sortPoints = sortPoints.concat(pointsList[l]);
        foundCount++;
      } else if (minMode == 3) {
        for (i = 0; i < j; i++) {
          sortPoints.push(pointsList[l][i]);
        }
        foundCount++;
      }
    }
    if (foundCount == totalLines) break;
  }

  let retCoors = [];
  let retPoints = [];
  for (i = 0; i < sortPoints.length; i++) {
    if (typeof sortPoints[i] == "undefined") {
      console.log("undefined");
    }
    p = transform(sortPoints[i], "EPSG:4326", "EPSG:3857");
    retCoors[2 * i] = p[0];
    retCoors[2 * i + 1] = p[1];
    retPoints[i] = p;
  }

  return [retCoors, retPoints];
}
function drawTip(text, fontSize) {
  //
  let canvas = document.createElement("canvas");
  let context = canvas.getContext("2d", { willReadFrequently: true });
  let length = text.length + 1;
  let trigw_h = 5;
  let trigh = 15;
  let x = 0;
  let y = 0;
  let w = length * (fontSize + 1);
  let halfw = w / 2;
  let h = fontSize * 2;

  context.fillStyle = " rgba(255, 255,170, 0.7)";
  // context.fillStyle =' rgba(255, 255, 255, 0)';
  context.strokeStyle = "rgba(32,52, 20, 0.5)";
  context.beginPath();
  context.moveTo(0, 0);
  context.lineTo(x, y + h);

  context.lineTo(x + halfw - trigw_h, y + h);
  context.lineTo(x + halfw, y + h + trigh);
  context.lineTo(x + halfw + trigw_h, y + h);

  context.lineTo(x + w, y + h);
  context.lineTo(x + w, y);
  context.lineTo(x, y);
  context.lineTo(0, 0);

  context.shadowColor = "rgba(0,0,0,0.1)";
  context.shadowBlur = 5;
  context.shadowOffsetX = 2;
  context.shadowOffsety = 2;
  context.closePath();
  context.fill();
  context.stroke();
  return [canvas, w, h + trigh];
}

function computeFontSize(str, size, family) {
  let spanDom = document.createElement("span");
  spanDom.style.fontSize = size + "px";
  spanDom.style.opacity = "0";
  spanDom.style.margin = "0px";

  // spanDom.style.fontFamily = family;
  spanDom.innerHTML = str;
  document.body.append(spanDom);
  let sizeD = {};
  sizeD.width = spanDom.offsetWidth;
  sizeD.height = spanDom.offsetHeight;
  spanDom.remove();
  return sizeD;
}

function cutTracepoints(points) {
  let traceCroods = points;
  let len = traceCroods.length;
  let destCroods = [];
  for (let i = 0; i < len - 1; ++i) {
    let bPoint = traceCroods[i];
    let ePoint = traceCroods[i + 1];
    let bevelling = Math.sqrt(
      Math.pow(ePoint[0] - bPoint[0], 2) + Math.pow(ePoint[1] - bPoint[1], 2)
    );
    let cosA = (ePoint[0] - bPoint[0]) / bevelling;
    let sinA = (ePoint[1] - bPoint[1]) / bevelling;

    let curStep = 0;
    let step = 50;
    destCroods.push([bPoint[0], bPoint[1]]);
    do {
      curStep++;
      let nextPoint;
      if (curStep * step >= bevelling) {
        nextPoint = [ePoint[0], ePoint[1]];
      } else {
        nextPoint = [
          cosA * curStep * step + bPoint[0],
          sinA * curStep * step + bPoint[1],
        ];
      }
      destCroods.push(nextPoint);
    } while (curStep * step < bevelling);
  }
  return destCroods;
}
function isDigitail(l) {
  const regDig = /^(\d)+(\d)$/;

  return regDig.test(l);
}

function getStringListSegment(txtList, fontSize, fontFamily, singleLine) {
  let rText = [];
  txtList.forEach((t) => {
    if (rText.length != 0) {
      rText.push("\n");
      rText.push("");
    }
    rText.push(t);
    rText.push(fontSize.toString() + "px " + fontFamily);
  });
  if (singleLine == 0 && rText.length > 0) {
    rText.push("\n");
    rText.push("");
  }
  return rText;
}
function getStringSegment(
  map,
  geoCoors,
  devName,
  fontSize,
  fontFamily,
  singleLine,
  minNumInSeg
) {
  const regChinese = /[\u4e00-\u9fa5]/;
  const splitChar = /['/\\#']/;
  let ps = map.getPixelFromCoordinate(geoCoors[0]);
  let pe = map.getPixelFromCoordinate(geoCoors[2]);

  let fw = computeFontSize(devName, fontSize, fontFamily);

  let rectW = Math.abs(pe[0] - ps[0]);
  let seg = 1,
    numInSeg = devName.length;
  let fww = parseInt(fw.width);
  if (rectW < fww && numInSeg > 3) {
    seg = parseInt(Math.round(fww / rectW));
    if (seg <= 0) seg = 1;
    numInSeg = parseInt(numInSeg / seg);
    if (numInSeg <= 0) numInSeg = 1;
  }
  if(minNumInSeg && numInSeg<minNumInSeg)
  {
    numInSeg=minNumInSeg 
    seg = parseInt(devName.length / numInSeg);
    if (seg <= 0) seg = 1;

  }
  let rText = [];
  if (seg > 1) {
    for (let i = 0; i < devName.length; ) {
      let t = devName.substring(i, i + numInSeg);
      i += numInSeg;
      for (; i < devName.length; ) {
        let c = t.substr(-1);
        let n = devName.substring(i, i + 1);
        if (!regChinese.test(c) && n == "线") {
          t += n;
          i++;
          break;
        }

        if (regChinese.test(c) || regChinese.test(n)) {
          break;
        }
        if (splitChar.test(c)) {
          break;
        }
        if (splitChar.test(c)) {
          break;
        }
        if (splitChar.test(n)) {
          t += n;
          i++;
          break;
        }
        t += n;
        i++;
      }
      if (rText.length != 0) {
        rText.push("\n");
        rText.push("");
      }
      rText.push(t);
      rText.push(fontSize.toString() + "px " + fontFamily);
    }
    // st.getText().setText(rText);
  } else {
    // let tl=window.common.computeFontSize(devName);
    // st.getText().setText(devName);
    if (singleLine) return [devName];
    if (rText.length != 0) {
      rText.push("\n");
      rText.push("");
    }
    rText.push(devName);
    rText.push(fontSize.toString() + "px " + fontFamily);
  }
  if (singleLine == 0 && rText.length > 0) {
    rText.push("\n");
    rText.push("");
  }
  return rText;
}


function getCommonStringSegment(devName, fontSize, fontFamily, numInSeg) {
  const regChinese = /[\u4e00-\u9fa5]/;
  const splitChar = /['/\\#']/;

  let fw = computeFontSize(devName, fontSize, fontFamily);

  let seg = 1;
  let fww = parseInt(fw.width);

  seg = devName.length / numInSeg;
  while (seg > 9) {
    numInSeg += 2;
    seg = devName.length / numInSeg;
  }
  let rText = [];
  if (seg > 1) {
    for (let i = 0; i < devName.length; ) {
      let t = devName.substring(i, i + numInSeg);
      i += numInSeg;
      for (; i < devName.length; ) {
        let c = t.substr(-1);
        let n = devName.substring(i, i + 1);
        if (!regChinese.test(c) && (n == "线" || n == "变")) {
          t += n;
          i++;
          break;
        }

        if (regChinese.test(c) || regChinese.test(n)) {
          break;
        }
        if (splitChar.test(c)) {
          break;
        }
        if (splitChar.test(c)) {
          break;
        }
        if (splitChar.test(n)) {
          t += n;
          i++;
          break;
        }
        t += n;
        i++;
      }
      rText.push(t);
    }
    // st.getText().setText(rText);
  } else {
    // let tl=window.common.computeFontSize(devName);
    // st.getText().setText(devName);

    rText.push(devName);
  }
  return rText;
}
function Anglejson2Gis(rota) {
  if (rota != 0) {
    // rota=360-rota;
    if (rota > 180) {
      rota -= 180;
      rota = 180 - rota;
    } else rota = -rota;
  }

  rota = rota * (Math.PI / 180);
  return rota;
}

function setConfPath() {
  ajax({
    method: "GET",
    url: "conf/appSceneCfg.json",
    async: false,
  }).done(function (msg) {
    window.global.appSceneCfg = msg;
    // sessionCfg = msg;
  });
}
function getConfPath(cfgName) {
  let confPath = "common";
  let sName = window.global.applicationScene;
  if (window.global.appSceneCfg.hasOwnProperty(sName)) {
    if (window.global.appSceneCfg[sName].includes(cfgName)) {
      confPath = sName;
    }
  }
  return "conf/" + confPath + "/" + cfgName;
}
function rgb2Hex(rgb){
    var _this = rgb;
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    if(/^(rgb|RGB)/.test(_this)){
        var aColor = _this.replace(/(?:(|)|rgb|RGB)*/g,"").split(",");
        var strHex = "#";
        for(var i=0; i<aColor.length; i++){
            var hex = Number(aColor[i]).toString(16);
            hex = hex<10 ? 0+''+hex :hex;// 保证每个rgb的值为2位
            if(hex === "0"){
                hex += hex;
            }
            strHex += hex;
        }
        if(strHex.length !== 7){
            strHex = _this;
        }
        return strHex;
    }else if(reg.test(_this)){
        var aNum = _this.replace(/#/,"").split("");
        if(aNum.length === 6){
            return _this;
        }else if(aNum.length === 3){
            var numHex = "#";
            for(var i=0; i<aNum.length; i+=1){
                numHex += (aNum[i]+aNum[i]);
            }
            return numHex;
        }
    }else{
        return _this;
    }
}
//#101010 -->rgba(32,32,32,1)
function hexToRgb(ihex,alph) {
  let result ;
  let malph=1.0;
  if (alph)
    malph=alph
  let hex=ihex.replace(/ /g,"");
  if(hex.startsWith("rgba"))
  {
    result=/^rgba\(?([\d]{1,3}),([\d]{1,3}),([\d]{1,3}),([01]{0,1}\.{0,}[\d]{0,})\)$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1]),
          g: parseInt(result[2]),
          b: parseInt(result[3]),
          alph:parseFloat(result[4])*malph,
        }
      : null;
  }
  else if(hex.startsWith("rgb"))
  {
    result=/^rgb\(?([\d]{1,3}),([\d]{1,3}),([\d]{1,3})\)$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1]),
          g: parseInt(result[2]),
          b: parseInt(result[3]),
          alp:malph
        }
      : null;
  }
  else if(hex.length<7)
  {
    result = /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16)*16,
          g: parseInt(result[2], 16)*16,
          b: parseInt(result[3], 16)*16,
          alph:malph,
        }
      : null;
    
  }
  else
  {
    result= /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
          alph:malph,
        }
      : null;
  }
}
function getWeatherFormatDate() 
{
    //获取新的时间(2019.4.12）
    let date = new Date();
    let year = date.getFullYear().toString();
    let month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1).toString()
        : (date.getMonth() + 1).toString();
    let da =
      date.getDate() < 10
        ? "0" + date.getDate().toString()
        : date.getDate().toString();
    let h = date.getHours() < 10
        ? "0" + date.getHours().toString()
        : date.getHours().toString();
    let m = date.getMinutes() < 10
        ? "0" + date.getMinutes().toString()
        : date.getMinutes().toString();
    let s = date.getSeconds() < 10
        ? "0" + date.getSeconds().toString()
        : date.getSeconds().toString();

    return [year,month,da,h,m,s]
}


function createColorCanvas(svg,objColor,fullImage)
{
  let myCanvas = document.createElement("canvas");
  let context = myCanvas.getContext("2d");
  context.drawImage(svg, 0, 0);
  // 修改SVG图像的填充颜色
  let imageData = context.getImageData(
    0,
    0,
    myCanvas.width,
    myCanvas.height
  );
  let data = imageData.data;
  if(objColor!="")
  {
    let rgb = hexToRgb(objColor);
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] != 0) {
        if (fullImage||(data[i] == 0xff &&data[i + 1] == 0xff &&data[i + 2] == 0xff)) {
          data[i] = rgb["r"]; // Red
          data[i + 1] = rgb["g"]; // Green
          data[i + 2] = rgb["b"]; // Blue
        }
      }
    }
  }
  context.putImageData(imageData, 0, 0);
  return myCanvas
}


function changePngColor(svg,objColor,fullImage)
{
  let myCanvas = document.createElement("canvas");
  let context = myCanvas.getContext("2d");
  context.drawImage(svg, 0, 0);
  // 修改SVG图像的填充颜色
  let imageData = context.getImageData(
    0,
    0,
    myCanvas.width,
    myCanvas.height
  );
  let data = imageData.data;
  if(objColor!="")
  {
    let rgb = hexToRgb(objColor);
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] != 0) {
        if (fullImage||(data[i + 3]!=0)) {
          data[i] = rgb["r"]; // Red
          data[i + 1] = rgb["g"]; // Green
          data[i + 2] = rgb["b"]; // Blue
        }
      }
    }
  }
  context.putImageData(imageData, 0, 0);
  return myCanvas
}

function getMapZoomInt()
{

  return parseInt(Math.round(window.global.map.getView().getZoom()))
}

function getMapZoomFloat()
{

  return Math.round(window.global.map.getView().getZoom())
}

function getThisMapZoomInt(map)
{

  return parseInt(Math.round(map.getView().getZoom()))
}

function getThisMapZoomFloat(map)
{

  return Math.round(map.getView().getZoom())
}
function addFlagIcon(coordinate,map,source,type) {
  if(type=="故障"){
    var iconStyle = new Style({
      image: new olIcon({
        src: 'img/home/guzhang.png', // 旗子的图片路径
        anchor: [0.5, 1] // 设置图标的锚点为底部中心
      })
    });
  }else if(type=="检修"){
    var iconStyle = new Style({
      image: new olIcon({
        src: 'img/home/检修.png', // 旗子的图片路径
        anchor: [0.5, 1] // 设置图标的锚点为底部中心
      })
    });
  }
  let  pos = transform(coordinate, 'EPSG:4326', 'EPSG:3857');
  // 创建一个特征点
  var flagFeature = new Feature({
    geometry: new Point(pos) // 使用坐标创建点几何对象
  });
  // 设置特征点的样式
  flagFeature.setStyle(iconStyle);
  source.addFeature(flagFeature);
  map.getView().animate({
    center:transform(coordinate, 'EPSG:4326', 'EPSG:3857'),
    duration:200,
    zoom:12
  })
}
function  createFlagLayer(map) {
      let t = 0;
      let falgSource = new Vector();
      let falgLayer = new VectorLayer({
        title: "",
        source:falgSource,
        declutter: false,
      });
      // window.global.falgLayer=falgLayer
      // window.global.falgSource=falgSource
      t = map.getLayers().getLength();
      falgLayer.setZIndex(t + 1);   
      map.addLayer(falgLayer);
      return falgLayer
    }


let loadingInstance=null;

function  calculateNumber(value) {
  let num = typeof value === 'string' ? parseFloat(value) : value
  if(num<1){
    return num.toFixed(2)
  }else if(num>1&&num<10){
    return num.toFixed(1)
  }else if(num>10){
    return Math.floor(num)
  }
}


export default {
  safeGetJsonKey,
  getFeatureProperties,
  valIsInArray,
  initVoltageCfg,
  getVoltageInfo,
  getVoltageFilterStr,
  getVoltageFilter,
  drawTip,
  sortLineCoordinates,
  computeFontSize,
  cutTracepoints,
  getStringSegment,
  getCommonStringSegment,
  getStringListSegment,
  Anglejson2Gis,
  hexToRgb,
  rgb2Hex,
  isDigitail,
  setConfPath,
  getConfPath,
  debounce,
  getWeatherFormatDate,
  createColorCanvas,
  getMapZoomInt,
  getMapZoomFloat,
  getThisMapZoomInt,
  getThisMapZoomFloat,
  initContextMenuCfg,
  changePngColor,
  addDays,
  addMonths,
  formatDate,
  formatFullDate,
  formatTime,
  addFlagIcon,
  createFlagLayer,
  calculateNumber
};
</script>
